import { SUPPORTED_YEARS } from '../data/annual-calendar/types';

/** Civil year for the calendar redirect. Not the server's UTC year. */
export const CALENDAR_TIME_ZONE = 'America/Denver';

/**
 * Denver's calendar year, clamped to the generated year pages.
 * Before the first page, use the first. After the last, stay on the last.
 */
export function currentCalendarYear(now: Date = new Date()): number {
  const year = Number(
    new Intl.DateTimeFormat('en-US', {
      timeZone: CALENDAR_TIME_ZONE,
      year: 'numeric',
    }).format(now),
  );
  const first = SUPPORTED_YEARS[0];
  const last = SUPPORTED_YEARS[SUPPORTED_YEARS.length - 1];
  if (year < first) return first;
  if (year > last) return last;
  return year;
}

/** Live annual calendar year promoted from /planner before Denver Jan 1 rolls over. */
export const PLANNER_PROMOTED_CALENDAR_YEAR = 2027;

/** Hero link on /planner: at least the promoted year, never past generated pages. */
export function plannerAnnualCalendarYear(now: Date = new Date()): number {
  const current = currentCalendarYear(now);
  const last = SUPPORTED_YEARS[SUPPORTED_YEARS.length - 1];
  return Math.min(Math.max(current, PLANNER_PROMOTED_CALENDAR_YEAR), last);
}

/**
 * Relative Location for the bare calendar URL. Keeps the query string.
 * Relative so the redirect never names a host taken from the request (ERI-2650).
 */
export function bareCalendarLocation(requestUrl: string, now: Date = new Date()): string {
  return `/milky-way-calendar/${currentCalendarYear(now)}${new URL(requestUrl).search}`;
}
